<template>
  <div class="row reverse-mobile justify-content-center" id="activity-feed">
    <div class="col-12 col-md-3 left-menu filters-section">
      <div class="position-sticky" style="top: 16px">
        <MyGroupsMini class="mb-3"></MyGroupsMini>
        <FavouriteScenariosList></FavouriteScenariosList>
      </div>
    </div>

    <div
      class="center-content col-12 col-md-6 d-flex flex-column justify-content-center align-items-center small-full"
    >
      <div class="w-100">
        <div v-if="posts.length < 1">
          <NoResults></NoResults>
        </div>

        <div v-else>
          <div class="results-count mb-2 ml-1">
            {{ posts.length }}
            Post{{ posts.length != 1 ? "s" : "" }} Available
          </div>

          <div>
            <ForumPost
              v-for="post in posts"
              :key="post.id"
              :postObj="post"
              v-on:reload-data="resetPosts"
              :groupObj="post.group"
            ></ForumPost>
          </div>
        </div>
        <infinite-loading @infinite="infiniteHandler" :identifier="infiniteId">
          <div slot="no-more">No more posts</div>
          <div slot="no-results"></div>
        </infinite-loading>
      </div>
    </div>

    <ScenarioTagFilter
      @tag-selection-updated="tagsUpdated"
      :availableTags="getScenarioTags"
      @filters-cleared="tagsUpdated([])"
    />
  </div>
</template>

<script>
import Paginate from "../components/Paginate";
import NoResults from "../components/NoResults";
import PleaseWait from "../components/PleaseWait";
import MyGroupsMini from "../components/MyGroupsMini";
import FavouriteScenariosList from "../components/FavouriteScenariosList";
import ForumPost from "../components/ForumPost";
import UserObject from "../objects/UserObject";
import forumgroupService from "../services/forumgroup.service";
import InfiniteLoading from "vue-infinite-loading";
import scenariosService from "../services/scenarios.service";
import ScenarioTagFilter from "../components/ScenarioTagFilter";

export default {
  name: "ActivityFeed",
  components: {
    Paginate,
    PleaseWait,
    NoResults,
    ForumPost,
    MyGroupsMini,
    FavouriteScenariosList,
    InfiniteLoading,
    ScenarioTagFilter,
  },
  data: function() {
    return {
      NUMBER_TO_GET: 5,
      posts: [],
      pageNum: 0,
      infiniteId: +new Date(),
      scenarioTags: [],
    };
  },
  props: {
    // Route has props: true so this is passed in as a param, otherwise defaults to false.
    // Used to check if the user has just signed in, so we can fetch needed data: i.e. favourite scenarios.
    performInitialFetch: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    tagsUpdated(tags) {
      this.isLoading = true;
      this.scenarioTags = tags;
      this.resetPosts();
    },
    getScenarioTags() {
      return scenariosService.scenarioTags();
    },
    infiniteHandler($state) {
      let startOffset = this.pageNum * this.NUMBER_TO_GET;
      this.pageNum += 1;

      forumgroupService
        .getPostsForActivityFeed(
          startOffset,
          this.NUMBER_TO_GET,
          this.scenarioTags
        )
        .then((data) => {
          this.posts.push(...data.posts);

          if (data.count < 1 || parseInt(data.to) >= data.total) {
            $state.complete();
            this.finishedLoading = true;
          } else {
            $state.loaded();
          }
        });
    },
    resetPosts() {
      this.pageNum = 0;
      this.posts = [];
      this.infiniteId++;
    },
  },
  mounted() {
    if (this.performInitialFetch) {
      this.$store.dispatch("favouritesStore/fetchFavouriteScenarios");
    }
  },
};
</script>

<style scoped>
#activity-feed {
  display: flex;
  flex-wrap: nowrap;
}

.edit-link {
  margin-left: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  text-decoration: none;
  padding: 4px;
}

.placeholder {
  min-height: 900px;
  z-index: 9;
  margin-bottom: 30px;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .sm-horizontal-scroll {
    max-width: 100vw;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.results-count {
  color: var(--isim-light-text);
  font-size: 14px;
  text-align: start;
}

.deep {
  color: #014a8f;
}

.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #224b8c;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

[v-cloak] {
  display: none !important;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@media (max-width: 575.98px) {
  .filters-section .list-group {
    flex-wrap: wrap;
    justify-content: center;
  }
  .filters-section .list-group .list-group-item {
    min-width: 40%;
    max-width: 48%;
    border-radius: 0px !important;
  }
  .small-full {
    width: 100% !important;
  }
  .small-full div:first-child {
    text-align: center;
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
    .pagination-wrapper {
      margin: 0px !important;
      padding: 0px !important;
      display: flex;
    }
    .pagination-wrapper ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}
</style>
